import { PlayMode } from '../../lottie-animation/lottie-animation';

/**
 * We did not have time to refactor the lottie animation component to accept
 * a media object, so we have to convert the media object to a lottie object
 * for the time being.
 */
export var convertMediaToLottie = function convertMediaToLottie(props) {
  var _props$media, _props$media2, _props$media3;

  return {
    src: ((_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.url) || '',
    playMode: PlayMode.Auto,
    loop: true,
    width: (_props$media2 = props.media) === null || _props$media2 === void 0 ? void 0 : _props$media2.width,
    height: (_props$media3 = props.media) === null || _props$media3 === void 0 ? void 0 : _props$media3.height
  };
};